<div class="step-content">
    <div class="step-header">
        <h2 class="step-title">Dentist information</h2>
    </div>

    <form [formGroup]="demographicFormGroup" class="form-grid">
        <div class="form-group">
            <app-date-input [ngClass] ="demographicFormGroup.controls['dob'].errors ? 'showAsterisk' : 'hideAsterisk'"  [for] = "'dob-Input'" [maxDate]="minDate" 
            label="Date of birth" [control]="demographicFormGroup.controls['dob']"
            [errorMessages]="{ required: 'Required', minAge: 'Provider must be at least 18 years old' }">
            >
            </app-date-input>
        </div>
        <div class="form-group">
            <app-select-input class="story-drop" [label]="'Gender'" [for] = "'gender-Input'" [placeholder]="'None selected'"
            [ngClass] ="demographicFormGroup.controls['gender'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [options]="genderOptions" [control]="demographicFormGroup.controls['gender']">
          </app-select-input>
        </div>
        <div class="form-group"> 
            <app-select-input class="story-drop" label="Ethnicity" [control]="demographicFormGroup.controls['ethnicity']"
            [ngClass] ="demographicFormGroup.controls['ethnicity'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [placeholder]="'None selected'" [for] = "'ethnicity-select'" [options]="ethinicityOptions"></app-select-input>
        </div>
        <div class="form-group"> 
            <div class="marg-t-35 find-wdth">
                <label class= "location-field" for="location-name">Home address</label>
                <input (focus) = "onFocus()" formControlName = "location" (ngModelChange) = "onLocationChange($event)" #locationInput type="text" id="location-name" 
                [title]="(demographicFormGroup.controls['location'].value?.length || 0) > 25 ? (demographicFormGroup.controls['location'].value || '') : ''"
                name="location" aria-label="Home address" class="findform-input location-fieldbox">
                <div *ngIf = "showError" class="finddentist-validator">Required</div>
            </div>
        </div>
        <div class="form-group">
            <app-text-input [label]="'City'" [for] = "'city-Input'" [maxLength]="FIELD_LIMITS['city']['maxLength']"
             [control]="demographicFormGroup.controls['city']"></app-text-input>
        </div> 
        <div class="form-group">
            <app-select-input class="story-drop" [label]="'State'" [for] = "'state-Input'" [placeholder]="'None selected'"
          [control]="demographicFormGroup.controls['state']" [options]="stateOptions" [isSearchable]="true"></app-select-input>
        </div> 
        <div class="form-group"> 
            <app-text-input label="Zip" [control]="demographicFormGroup.controls['zip']" [maxLength]="FIELD_LIMITS['zip']['maxLength']"
            [for] = "'zip-Input'" [fieldType]="'This field'" (keypress)="restrictNonNumeric($event)" [errorMessages]="customErrorMessagesZip"></app-text-input>
        </div>
        <div class="form-group"> 
            <app-text-input label="Email" [control]="demographicFormGroup.controls['email']"
            [for] = "'email-Input'" [maxLength]="FIELD_LIMITS['email']['maxLength']"
            [ngClass] ="demographicFormGroup.controls['email'].errors ? 'showAsterisk' : 'hideAsterisk'"></app-text-input>
        </div> 
        <div class="form-group"> 
            <app-select-input class="story-drop" label="Dental school" [control]="demographicFormGroup.controls['dentalSchool']"
            [ngClass] ="demographicFormGroup.controls['dentalSchool'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [for] = "'dentalSchool-select'" [options]="schoolsList" (selectionChanged)="onSchoolChange()"[isSearchable]="true" ></app-select-input>
        </div>
        <div class="form-group"> 
            <app-text-input label="Other school name" [control]="demographicFormGroup.controls['otherSchool']"
            [maxLength]="FIELD_LIMITS['otherSchool']['maxLength']" [errorMessages]="{required: 'Required'}"
            [ngClass]="demographicFormGroup.controls['otherSchool'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [for] = "'otherSchool-Input'"></app-text-input>
        </div> 
        <div class="form-group">
            <app-date-input [label]="'Graduation date'" [maxDate]="today" [for] = "'yearGraduated-select'" 
            [ngClass] ="demographicFormGroup.controls['yearGraduated'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [control]="demographicFormGroup.controls['yearGraduated']"
            [errorMessages]="{ required: 'Required', futureDate: 'Graduation date cannot be in the future' }">
            >
          </app-date-input>
        </div> 
        <div class="form-group">
            <app-select-input class="story-drop" [label]="'Specialty'" [for] = "'specialty-select'" [placeholder]="'None selected'"
            [ngClass] ="demographicFormGroup.controls['specialty'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [options]="specialityList" [control]="demographicFormGroup.controls['specialty']">
          </app-select-input>
        </div> 
        <div class="form-group">
            <app-select-input class="story-drop" [label]="'Degree'" [for] = "'degree-select'" [placeholder]="'None selected'"
            [ngClass] ="demographicFormGroup.controls['degree'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [options]="degreeOptions" [control]="demographicFormGroup.controls['degree']" [isSearchable]="true" >
          </app-select-input>
        </div> 
        <div class="form-group">
            <app-select-input class="story-drop" [label]="'Education type'" [for] = "'Education type-select'" [placeholder]="'None selected'"
            [options]="educationTypeOptions" [control]="demographicFormGroup.controls['educationType']" [isSearchable]="true" >
          </app-select-input>
        </div> 
    </form>

    <app-wizard-navigation [showBack]="true" [showNext]="true" [showCancel]="true" (back)="onBack()" (next)="onNext(false)" (cancel)="onCancel()">
    </app-wizard-navigation>
</div>